import React from 'react';
import { Provider } from 'react-redux';
import store from '../../utils/store';
import VoiceActorWorksheetPageEnh from './pages/VoiceActorWorksheetPageEnh';

/**
 * VoiceActorWorksheetPageWrapperEnh component
 * Wrapper component that provides Redux store to the VoiceActorWorksheetPageEnh
 * @returns {JSX.Element} VoiceActorWorksheetPageWrapperEnh component
 */
const VoiceActorWorksheetPageWrapperEnh = () => {
  return (
    <Provider store={store}>
      <VoiceActorWorksheetPageEnh />
    </Provider>
  );
};

export default VoiceActorWorksheetPageWrapperEnh;
